import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  setFilterEconomicLossMax,
  setFilterEconomicLossMin,
} from "../../../actions/filters";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const PREFIX = 'Losses';

const classes = {
  root: `${PREFIX}-root`,
  losses: `${PREFIX}-losses`,
  inputContainer: `${PREFIX}-inputContainer`,
  select: `${PREFIX}-select`,
  divider: `${PREFIX}-divider`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.losses}`]: {
    // width: "10rem",
    marginRight: "-0.5rem",
    marginTop: "12px !important",
    "& h5": {
      fontWeight: "normal",
      color: "rgba(0, 0, 0, 0.54)",
      margin: "0 0 0.5rem 0",
      fontSize: "0.75rem",
    },
  },

  [`& .${classes.inputContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "-2px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "start",
    },
  },

  [`& .${classes.select}`]: {
    background: "#fff",
    "& .MuiSelect-outlined": {
      height: "0.3rem !important",
      minHeight: "0.3rem !important",
      width: "6rem",
      // padding: 0,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "0.9rem",
      marginTop: "-1rem",
    },
    " & .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  },

  [`& .${classes.divider}`]: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "0.75rem",
    margin: "0 0.5rem",
    display: "flex",
    alignItems: "center",
  }
}));

const StyledBox = styled(Box)((
  {
    theme
  }
) => ({
  [`&.${classes.losses}`]: {
    // width: "10rem",
    marginRight: "-0.5rem",
    marginTop: "12px !important",
    "& h5": {
      fontWeight: "normal",
      color: "rgba(0, 0, 0, 0.54)",
      margin: "0 0 0.5rem 0",
      fontSize: "0.75rem",
    },
  },

  [`& .${classes.inputContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "-2px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "start",
    },
  },

  [`& .${classes.select}`]: {
    background: "#fff",
    "& .MuiSelect-outlined": {
      height: "0.3rem !important",
      minHeight: "0.3rem !important",
      width: "6rem",
      // padding: 0,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "0.9rem",
      marginTop: "-1rem",
    },
    " & .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  },

  [`& .${classes.divider}`]: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "0.75rem",
    margin: "0 0.5rem",
    display: "flex",
    alignItems: "center",
  }
}));

const Losses = ({
  setFilterEconomicLossMax,
  setFilterEconomicLossMin,
  analyses,
  minFilter,
  maxFilter,
}) => {

  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [choices, setChoices] = useState([]);

  const removeNonNumbers = (string) => {
    const strSplit = string.split("");
    return strSplit.filter((x) => !isNaN(parseInt(x))).join("");
  };

  const formatDisplayValue = (value) => {
    return `$${parseInt(value).toLocaleString()}`;
  };

  const onChangeMax = (event, child) => {
    const value = child.props.value;
    setMax(value);
    value.length > 0
      ? setFilterEconomicLossMax(removeNonNumbers(value))
      : setFilterEconomicLossMax(null);
  };

  const onChangeMin = (event, child) => {
    const value = child.props.value;
    setMin(value);
    value.length > 0
      ? setFilterEconomicLossMin(removeNonNumbers(value))
      : setFilterEconomicLossMin(null);
  };

  useEffect(() => {
    let _choices = [];
    analyses.forEach((analysis) => {
      if (analysis.totalLosses) {
        _choices.push(analysis.totalLosses);
      }
    });
    _choices = _choices.sort((a, b) => a > b);
    _choices = _choices.map((choice) => formatDisplayValue(choice));
    setChoices(_choices);
  }, [analyses]);

  useEffect(() => {
    minFilter === null && setMin("");
  }, [minFilter]);

  useEffect(() => {
    maxFilter === null && setMax("");
  }, [maxFilter]);

  return (
	<Root className={classes.root}>
		<div>
		    <StyledBox className={classes.losses}>
		      <h5>Economic Loss</h5>
		      <Box className={classes.inputContainer}>
		        <Select
		          id="min"
		          className={classes.select}
		          placeholder="min"
		          value={min}
		          onChange={onChangeMin}
		          displayEmpty
		          inputProps={{ "aria-label": "Without label" }}
		        >
		          <MenuItem value="">
		            <em>None</em>
		          </MenuItem>
		          {choices &&
		            choices.map((choice, idx) => {
		              return (
		                <MenuItem key={`choice-min-${idx}`} value={choice}>
		                  {choice}
		                </MenuItem>
		              );
		            })}
		        </Select>
		        <span className={classes.divider}>to</span>
		        <Select
		          id="max"
		          className={classes.select}
		          placeholder="max"
		          value={max}
		          onChange={onChangeMax}
		          displayEmpty
		          inputProps={{ "aria-label": "Without label" }}
		        >
		          <MenuItem value="">
		            <em>None</em>
		          </MenuItem>
		          {choices &&
		            choices.map((choice, idx) => {
		              return (
		                <MenuItem key={`choice-max-${idx}`} value={choice}>
		                  {choice}
		                </MenuItem>
		              );
		            })}
		        </Select>
		      </Box>
		    </StyledBox>
		</div>
	</Root>
  );
};

Losses.propTypes = {
  setFilterEconomicLossMax: PropTypes.func.isRequired,
  setFilterEconomicLossMin: PropTypes.func.isRequired,
  minFilter: PropTypes.number.isRequired,
  maxFilter: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  analyses: state.details.analyses,
  minFilter: state.filters.economicLossMin,
  maxFilter: state.filters.economicLossMax,
});

export default connect(mapStateToProps, {
  setFilterEconomicLossMax,
  setFilterEconomicLossMin,
})(Losses);
